<template>
    <input type="hidden" name="_token" :value="token">
</template>

<script>
    export default {
        name: "CsrfField",
        props: [
            'token'
        ]
    }
</script>

<style scoped>

</style>